export default __webpack_public_path__ + "static/media/nesto-inaam-rewards.5c0e8a28.png";